import Markdown, { defaultUrlTransform } from 'react-markdown'
import remarkGfm from 'remark-gfm'

// react-markdown ne laisse passer par défaut que https?, ircs?, mailto et
// xmpp (voir defaultUrlTransform) : un lien tel:, comme celui du numéro de
// téléphone de ces pages, serait sinon silencieusement réduit à href="".
export function urlTransform(url) {
  if (url.startsWith('tel:')) return url
  return defaultUrlTransform(url)
}

/**
 * Le rendu du Markdown des pages légales — un seul endroit, parce que les deux
 * pages sont alimentées par le même éditeur du back-office et doivent
 * interpréter exactement le même Markdown.
 *
 * remarkGfm : react-markdown s'en tient au CommonMark, qui ne connaît pas les
 * tableaux. Sans ce greffon, l'inventaire des traceurs de l'article 7 des CGU
 * s'afficherait en texte brut, tubes verticaux compris.
 */
export function TexteLegal({ children }) {
  return (
    <Markdown remarkPlugins={[remarkGfm]} urlTransform={urlTransform}>
      {children}
    </Markdown>
  )
}
